import { useEffect } from 'react';

import { useAccountProfileView } from '#/features/account/account-profile-context';
import {
  useUsernamePromptModalView,
  useUsernamePromptModalActions,
} from '#/features/account/username-prompt-modal-context';
import { UsernameFormProvider } from '#/features/account/username-form-context';

import UsernamePromptModal from './UsernamePromptModal';

export default function UsernamePrompter() {
  const accountProfileView = useAccountProfileView();
  const modalView = useUsernamePromptModalView();
  const modalActions = useUsernamePromptModalActions();

  useEffect(() => {
    if (accountProfileView.shouldPromptForUsername) {
      modalActions.open();
    }
  }, [accountProfileView.shouldPromptForUsername, modalActions]);

  if (!modalView.isOpen) return null;

  return (
    <UsernameFormProvider>
      <UsernamePromptModal />
    </UsernameFormProvider>
  );
}
